import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=5b63bdb8&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"
import style0 from "./Control.vue?vue&type=style&index=0&id=5b63bdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63bdb8",
  null
  
)

export default component.exports